import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrl } from 'src/environments/environment';
import { Area } from '../_models/area.model';
import { Response } from '../_models/response.model';

@Injectable({
  providedIn: 'root',
})
export class AreaService {
  areasUrl =  'api/Areas';

  constructor(private http: HttpClient) {}

  getAllAreas(): Observable<any> {
    return this.http.get(this.areasUrl);
  }

  getAreaById(id: number): Observable<any> {
    return this.http.get(`${this.areasUrl}/${id}`);
  }

  addArea(area: Area): Observable<any> {
    return this.http.post(this.areasUrl, area);
  }

  deleteArea(id: number): Observable<any> {
    return this.http.delete(`${this.areasUrl}/${id}`);
  }

  updateArea(area: Area): Observable<any> {
    return this.http.put(this.areasUrl, area);
  }

  changeActivationForArea(
    id: number,
    activationFlag: boolean
  ): Observable<any> {
    return this.http.put(`${this.areasUrl}/${id}/${activationFlag}`, {});
  }

  getAreasByCityId(id: number): Observable<any> {
    return this.http.get(`${this.areasUrl}/GetByCityId/${id}`);
  }

  getStringAreaName(id: number): Observable<Response<Area>> {
    return this.http.get<Response<Area>>(`${this.areasUrl}/${id}`);
  }

  searchByName(areaName) {
    return this.http.get(`${this.areasUrl}/SearchByName/${areaName}`);
  }
}
